<template>
    <modal id="order-status-modal"
           v-model="showModal"
           :title="`<b>${$t('move_to')}: </b>${status.translated_name}`"
           :preloader="preloader"
           @submit="saveStatus"
           :loading="loading"
    >
        <app-form-group
                :label="$t('note')"
                type="textarea"
                v-model="formData.note"
                :placeholder="$placeholder('note')"
                :error-message="$errorMessage(errors, 'note')"
                :text-area-rows="5"
        />
    </modal>
</template>

<script>
    import ModalMixin from "../../../Mixins/ModalMixin";
    import FormHelperMixin from "../../../Mixins/FormHelperMixin";
    import {axiosPatch} from "../../../Helpers/AxiosHelper";
    import {ORDERS} from "../../../Config/ApiUrl";

    export default {
        name: "OrderStatusChangeModal",
        mixins: [ModalMixin, FormHelperMixin],
        props: {
            status: {
                type: Object,
            },
            order_id: {}
        },
        methods: {
            saveStatus() {
                this.loading = true;
                axiosPatch(`/${ORDERS}/${this.order_id}/change-status`, this.formData)
                    .then(response => {
                        this.toastAndReload(response.data.message, 'orders-table');
                        this.$emit('input', false);
                        $("#order-status-modal").modal('hide');
                    })
                    .catch(({response}) => {
                        this.$toastr.e(response.data.message);
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            }
        }
    }
</script>

<style scoped>

</style>